"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports["default"] = exports.ButtonProps = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _colorManipulator = require("@material-ui/core/styles/colorManipulator");

var _makeStyles = _interopRequireDefault(require("../styles/makeStyles"));

var _TrackingWrapper = _interopRequireDefault(require("../TrackingWrapper"));

var _core = require("@material-ui/core");

var styles = function styles(theme) {
  return {
    rootShared: {
      padding: 0,
      position: 'relative',
      borderWidth: '2px',
      borderStyle: 'solid',
      '&:hover': {
        borderWidth: '2px',
        boxShadow: theme.shadows[8]
      },
      '&:focus': (0, _defineProperty2["default"])({
        outline: "1px dotted ".concat(theme.palette.common.black)
      }, "outline", '5px auto -webkit-focus-ring-color')
    },
    small: {
      minHeight: 30,
      minWidth: theme.spacing(10.25),
      borderRadius: theme.shape.borderRadius,
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1)
    },
    medium: {
      minHeight: 38,
      minWidth: theme.spacing(12.125),
      borderRadius: theme.shape.borderRadius,
      paddingRight: theme.spacing(2.25),
      paddingLeft: theme.spacing(2.25)
    },
    large: {
      minHeight: 44,
      minWidth: theme.spacing(14.125),
      borderRadius: theme.shape.borderRadius,
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3)
    },
    mega: {
      minHeight: 58,
      minWidth: theme.spacing(16.25),
      borderRadius: theme.shape.borderRadius,
      paddingRight: theme.spacing(4.125),
      paddingLeft: theme.spacing(4.125)
    },
    disabled: {},
    containedPrimary: {
      '&$disabled': {
        color: theme.palette.grey[500],
        backgroundColor: theme.palette.grey[400]
      },
      '&:hover': {
        '&$disabled': {
          color: theme.palette.grey[500],
          backgroundColor: theme.palette.grey[400]
        }
      }
    },
    label: (0, _extends2["default"])({}, theme.typography.body1, {
      textTransform: 'uppercase',
      letterSpacing: theme.spacing(0.15375),
      fontSize: theme.spacing(1.75),
      color: 'inherit'
    }),
    transparentBorder: {
      borderColor: 'transparent'
    }
  };
};

exports.styles = styles;
var useStyles = (0, _makeStyles["default"])(styles);
/**
 * Indicates the primary action.
 */

var Button = function Button(_ref) {
  var Component = _ref.Component,
      className = _ref.className,
      color = _ref.color,
      endIcon = _ref.endIcon,
      fullWidth = _ref.fullWidth,
      dataQa = _ref.dataQa,
      type = _ref.type,
      variant = _ref.variant,
      disabled = _ref.disabled,
      children = _ref.children,
      onClick = _ref.onClick,
      size = _ref.size,
      startIcon = _ref.startIcon;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_core.Button, {
    component: Component,
    disableTouchRipple: true,
    endIcon: endIcon,
    startIcon: startIcon,
    fullWidth: fullWidth,
    type: type,
    variant: variant,
    color: color,
    disabled: disabled,
    onClick: onClick,
    "data-qa": dataQa,
    className: className,
    classes: {
      root: (0, _classnames["default"])(classes.rootShared, classes[size], (0, _defineProperty2["default"])({}, classes.transparentBorder, variant !== 'outlined')),
      label: classes.label,
      disabled: classes.disabled,
      containedPrimary: classes.containedPrimary
    }
  }, children);
};

var ButtonProps = {
  /** The color of the component */
  color: _propTypes["default"].oneOf(['primary', 'secondary']),

  /** Selector for QA */
  dataQa: _propTypes["default"].string.isRequired,

  /** If `true`, the button will expand to fit its container */
  fullWidth: _propTypes["default"].bool,

  /** Button type */
  type: _propTypes["default"].oneOf(['button', 'submit', 'reset']),

  /** Styling applied to the button. */
  variant: _propTypes["default"].oneOf(['text', 'contained', 'outlined']),

  /** If `true`, the primary button will be disabled. */
  disabled: _propTypes["default"].bool,
  Component: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].elementType]),

  /** The content of the component. */
  children: _propTypes["default"].node.isRequired,

  /**
   * Callback fired when the component is clicked.
   *
   * **Signature:**
   * ```
   * function(event: object) => void
   * ```
   * *event*: The event source of the callback.
   */
  onClick: _propTypes["default"].func,

  /** Button size */
  size: _propTypes["default"].oneOf(['small', 'medium', 'large', 'mega'])
};
exports.ButtonProps = ButtonProps;
Button.propTypes = ButtonProps;
Button.defaultProps = {
  type: 'button',
  variant: 'contained',
  disabled: false,
  color: 'primary',
  size: 'medium'
};

var _default = (0, _TrackingWrapper["default"])(Button, 'Button click');

exports["default"] = _default;